module.exports = __webpack_public_path__ + "img/lb2.a7899cd1.svg";